export const passwordCriteria =
	'8 characters minimum, One number, One uppercase letter, One special character (_-:*).';
